import { ORG_DESCENDANTS_API } from 'constants/AppConstants';

export default async (orgNodeId) => {
  try {
    const response = await fetch(ORG_DESCENDANTS_API.replace(':orgId', orgNodeId));

    if (response.status === 403) return { ok: true, json: { userNotAuthorized: true } };

    const json = await response.json();

    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
